// ABOUTME: A polite live region, hidden on screen, that tells a screen reader which carousel item is focused and where.
// ABOUTME: It is the only announcement a carousel makes, since the browsing arrows change the item without moving focus.

import { Box } from '@mui/material';
import { visuallyHidden } from '../../runner/visuallyHidden';

interface PickStatusProps {
  name?: string;
  index: number;
  count: number;
}

export default function PickStatus({ name, index, count }: PickStatusProps) {
  return <Box role="status" sx={visuallyHidden}>{name ? `${name}, ${index + 1} of ${count}` : ''}</Box>;
}
